import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HeaderQuestionarioComponent } from './components/header-questionario/header-questionario.component';
import { CommonModule } from '@angular/common';
import { NgbAlertModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertComponent } from './components/alert/alert.component';
import { LoaderComponent } from './components/loader/loader.component';

const COMPONENTS = [
  HeaderQuestionarioComponent,
  AlertComponent,
  LoaderComponent,
];

@NgModule({
  imports: [CommonModule, NgbModule, NgbAlertModule, COMPONENTS],
  exports: [COMPONENTS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [],
})
export class SharedModule {}
